import {Formik} from "formik";
import {Dispatch, SetStateAction, useCallback, useContext, useEffect, useMemo, useState} from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { IConfigTable } from "../../models/OctResponse";
import {CODE_SUCCESS, CriteriaLevels, ERROR_MESSAGE} from "../../utils/Constant";
import CriteriaTable from "../components/CriteriaTable";
import {
  EVALUATE_STATUS,
  RESULT,
  TYPE_MODAL,
} from "../constants/criteriaModal";
import EvaluateDetailsModal from "./EvaluateDetailsModal";
import {
  getLogAssessment,
  getSubSessionByPlanCriteria,
} from "../services/CriteriaServices";
import { toast } from "react-toastify";
import { AppContext } from "../../appContext/AppContext";
import {generateForm, getCriteriaLevels} from "../../utils/AppFunction";
import GenerateFormComponent from "../../component/generate-form/GenerateFormHTMLNoValid";
import ModalHeader from "../../component/ModalHeader";
import {useCriteriaReportContext} from "../context/CriteriaReportContext";
import {LIST_CRITERIA} from "../constants/commons";
import {qualityIndicatorCriteria} from "../fakeData/qualityIndicator";

type Props = {
  show: boolean;
  handleCloseDialog: () => void;
  type: {
    form: string;
    modalType: string;
  };
};

const CriteriaModal = (props: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const {criteria, setCriteria, criteriaType} = useCriteriaReportContext();
  const {show, handleCloseDialog, type} = props;
  const {_83_TIEU_CHI, _CHI_SO_CHAT_LUONG, _TIEU_CHUAN_CHAT_LUONG, _XEP_CAP_CHUYEN_MON_KT, _MUC_DO_ATPT} = LIST_CRITERIA;

  const [objectSearch, setObjectSearch] = useState<any>();
  const [configTable, setConfigTable] = useState<IConfigTable>({
    totalPages: 1,
    totalElements: 5,
    numberOfElements: 5,
  });
  const [dataTable, setDataTable] = useState<any>();
  const [dataTableDetailRow, setDataTableDetailRow] = useState<any>();
  const [showEvaluateDetailsModal, setShowEvaluateDetailsModal] =
    useState(false);
  const [tableCache, setTableCache] = useState<{ [key: string]: any[] }>({});
  const [reload, setReload] = useState(false);
  const [saved, setSaved] = useState(false);
  const [formJson, setFormJson] = useState<any>([]);

  const titleByType = {
    [TYPE_MODAL.EVALUATE]: "Đánh giá báo cáo",
    [TYPE_MODAL.EDIT]: "Báo cáo tiêu chí",
    [TYPE_MODAL.VIEW]: "Xem báo cáo tiêu chí",
  }

  const is83Criteria = useMemo(() => criteriaType.value === _83_TIEU_CHI.value, [criteriaType.value]);
  const isQualityStandard = useMemo(() => criteriaType.value === _CHI_SO_CHAT_LUONG.value, [criteriaType.value]);

  useEffect(() => {
    updateForm().then(r => r);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (criteria?.id) {
      console.log(criteria)
      setObjectSearch({
        planId: criteria?.planId,
        criteriaId: criteria?.criteriaId,
        planCriteriaId: criteria?.id,
        level: is83Criteria ? CriteriaLevels.LEVEL_1 : "0",
      });

      setCriteria((pre: any) => ({
        ...pre,
        criteriaText: [pre?.criteriaId, pre?.criteriaName].join(" - "),
        partText: [pre?.partCode, pre?.partName].join(" - "),
        chapterText: [pre?.chapterCode, pre?.chapterName].join(" - "),
      }))
    }
    switch (criteriaType.value) {
      case _CHI_SO_CHAT_LUONG.value:
        setCriteria((pre: any) => {
          const newCriteria = {
            ...pre,
          };
          console.log(newCriteria)

          setDataTable([newCriteria]);
          return newCriteria;
        })
        break;
      case _XEP_CAP_CHUYEN_MON_KT.value:
      case _MUC_DO_ATPT.value:
      case _TIEU_CHUAN_CHAT_LUONG.value:
      case _83_TIEU_CHI.value:
      default:
        handleGetSubSessionByPlanCriteria(true);
        break;
    }
  }, [criteriaType.value, criteria?.id]);

  // Khi objectSearch thay đổi (ví dụ: chuyển sang level khác), dùng cache nếu có
  useEffect(() => {
    if ((objectSearch?.level || !is83Criteria) && !isQualityStandard) {
      handleGetSubSessionByPlanCriteria(false);
    }
  }, [objectSearch]);

  // Khi reload (ấn Save), luôn gọi lại API và ghi đè cache
  useEffect(() => {
    if ((objectSearch?.level || !is83Criteria) && !isQualityStandard) {
      handleGetSubSessionByPlanCriteria(true);
    }
  }, [reload]);

  const updateForm = async () => {
    if (type.form) {
      const data = await generateForm(type.form, setIsLoading);
      setFormJson(data || []);
    }
  };

  const handleSubmit = (values: any) => {
    if (type.modalType === TYPE_MODAL.EVALUATE && !saved) {
      toast.warning("Vui lòng hoàn thành đánh giá trước!");
      return;
    }

    const newValues = {
      planId: criteria?.planId,
      criteriaId: criteria?.criteriaId,
      planCriteriaId: criteria?.id,
      level: values?.level?.id,
    };
    setObjectSearch(newValues);
  }

  const handleGetSubSessionByPlanCriteria = async (
    forceReload: boolean = false
  ): Promise<void> => {
    const key = objectSearch?.level;
    const cachedData = tableCache[key];

    if (!forceReload && cachedData) {
      setDataTable(cachedData);
      return;
    }
    console.log(objectSearch)
    // const { planCriteriaId, ...rest } = objectSearch;
    delete objectSearch["planCriteriaId"]
    setIsLoading(true);

    try {
      const { data } = await getSubSessionByPlanCriteria(objectSearch);
      if (data?.code === CODE_SUCCESS) {
        const newData = data?.data?.map((item: any) => ({
          ...item,
          pointSelfAssessment:
            RESULT.find(
              (result: any) => result.id === item?.pointSelfAssessment
            ) || null,
          conclusionAssessment:
            RESULT.find(
              (result: any) => result.id === item?.conclusionAssessment
            ) || null,
          evidence: {
            id: item?.fileId,
            name: item?.fileName,
          },
          benchmark: 4,
        })) || [];

        if (newData?.length === 0) {
          newData.push({
            ...criteria,
            subsectionName: criteria?.criteriaName,
          })
        }

        const checkStatusEvaluated = newData?.every(
          (item: any) => +item?.status === EVALUATE_STATUS.EVALUATED.code
        );

        if (checkStatusEvaluated) {
          setSaved(true);
        } else {
          setSaved(false);
        }

        setDataTable(newData);

        setConfigTable({
          totalPages: data.data.totalPages,
          totalElements: data.data.totalElements,
          numberOfElements: data.data.numberOfElements,
        });

        setTableCache((prev) => ({
          ...prev,
          [key]: newData,
        }));
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDoubleClick = async (data: any) => {
    if (!data?.id) {
      return toast.warning("Vui lòng đánh giá trước khi xem chi tiết");
    }

    const params = {
      assessmentId: data?.id,
    };
    setIsLoading(true);
    try {
      const { data } = await getLogAssessment(params);
      if (data?.code === CODE_SUCCESS) {
        setDataTableDetailRow(data?.data);
        setShowEvaluateDetailsModal(true);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderSearchBtn = useCallback((props: { data: any }) => {
    const label = props.data?.dataComponent?.label || "";
    const values = props.data?.values || {};
    console.log(props);

    return (
      <div className="align-items-center d-flex h-100">
        <Button
          className="btn btn-fill min-w-120px spaces mx-3"
          onClick={() => setObjectSearch((pre: any) => ({...pre, level: values.level}))}
        >
          {label || ""}
        </Button>
      </div>
    )
  }, [setObjectSearch])

  return (
    <Modal
      className="page-full"
      fullscreen
      dialogClassName="h-modal"
      size="xl"
      show={show}
      animation={false}
      centered
      backdropClassName="spaces top-50"
    >

      <Formik
        enableReinitialize
        initialValues={{[type.form]: {...criteria}}}
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModalHeader onHide={handleCloseDialog} title={titleByType[type.modalType]} />
            <Modal.Body className="px-0 py-0 spaces overflow-hidden h-calc-vh-90 bg-white">
              <div className="spaces px-10">
                <GenerateFormComponent
                  // isView={isView}
                  listFieldAuto={formJson}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  touched={touched}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  modelID={type.form}
                  DynamicClass={"pl-38"}
                  customComponent={renderSearchBtn}
                />
              </div>

              <div className="spaces px-10">
                <CriteriaTable
                  dataTable={dataTable}
                  setDataTable={setDataTable}
                  objectSearch={objectSearch}
                  setObjectSearch={setObjectSearch}
                  configTable={configTable}
                  setConfigTable={setConfigTable}
                  handleDoubleClick={handleDoubleClick}
                  type={type}
                  tableCache={tableCache}
                  setTableCache={setTableCache}
                  reload={reload}
                  setReload={setReload}
                />
              </div>

              {showEvaluateDetailsModal && (
                <EvaluateDetailsModal
                  show={showEvaluateDetailsModal}
                  handleCloseDialog={() => setShowEvaluateDetailsModal(false)}
                  dataTableDetailRow={dataTableDetailRow}
                />
              )}
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CriteriaModal;
